const en = {
    new_product: 'New produt',
    select_active: 'only active',
    placeholder_search_reg: 'Search',
    sku:'SKU',
    description:'Description',
    brand:'Brand',
    price:'Price',
    stock:'Quantity',
    active:'Active',
    deactive:'Deactive',
    options:'Option',
    edit: 'Edit',
    delete: 'Delete',
    save:'save',
    sku_used: 'Used sku',
    catalogue:'Catalogue',
    product:'Product',
    new:'New',
    back:'Back'
}

export default en;